import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEdit, FaTrash, FaUser } from "react-icons/fa";
import axios from "axios";
import { toast } from "react-toastify";

const CardTestimoni = ({ id, name, role, content, avatar_url, onDelete }) => {
  const navigate = useNavigate();
  const [showDeletePrompt, setShowDeletePrompt] = useState(false);

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`/api_w/testimonials/${id}`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          db_name: process.env.REACT_APP_DB_NAME,
        },
      });

      onDelete(id);

      toast.success("Berhasil Hapus Testimoni");
    } catch (error) {
      toast.error(
        "Error Hapus Testimoni: " +
          (error.response?.data?.message || error.message)
      );
    } finally {
      setShowDeletePrompt(false);
    }
  };

  return (
    <>
      {" "}
      <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm dark:border-navy-600 dark:bg-navy-700">
        {/* Avatar */}{" "}
        <div className="flex justify-center pt-6">
          {avatar_url ? (
            <img
              src={avatar_url}
              alt={name}
              className="h-20 w-20 rounded-full object-cover ring-4 ring-gray-100"
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          ) : (
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-gray-100 text-gray-400">
              {" "}
              <FaUser className="h-8 w-8" />{" "}
            </div>
          )}{" "}
        </div>
        {/* Card Body */}
        <div className="p-5 text-center">
          {/* Name */}
          <h3 className="mb-1 line-clamp-1 text-lg font-semibold text-navy-700 dark:text-white">
            {name}
          </h3>

          {/* Role */}
          {role && <p className="mb-3 text-sm text-gray-500">{role}</p>}

          {/* Content */}
          <p className="mb-5 line-clamp-4 min-h-[96px] text-sm leading-relaxed text-gray-600">
            {content}
          </p>

          {/* Action Buttons */}
          <div className="flex items-center gap-2">
            {/* Button Edit */}
            <button
              onClick={() => navigate(`/admin/edit-testimoni/${id}`)}
              className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-blue-50 py-2 text-xs font-medium text-blue-600 transition-colors hover:bg-blue-100"
            >
              <FaEdit className="h-3.5 w-3.5" />
              Edit
            </button>

            {/* Button Hapus */}
            <button
              onClick={() => setShowDeletePrompt(true)}
              className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-red-50 py-2 text-xs font-medium text-red-500 transition-colors hover:bg-red-100"
            >
              <FaTrash className="h-3.5 w-3.5" />
              Hapus
            </button>
          </div>
        </div>
      </div>
      {/* Delete Modal */}
      {showDeletePrompt && (
        <div className="bg-black/50 fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm">
          <div className="mx-4 w-full max-w-sm rounded-2xl bg-white p-6 shadow-2xl">
            {/* Icon */}
            <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-red-50">
              <FaTrash className="h-5 w-5 text-red-500" />
            </div>

            {/* Title */}
            <h3 className="mb-2 text-lg font-bold text-navy-700">
              Hapus Testimoni?
            </h3>

            {/* Description */}
            <p className="mb-6 text-sm text-gray-500">
              Apakah Anda yakin ingin menghapus testimoni dari{" "}
              <strong>{name}</strong>?
            </p>

            {/* Action Buttons */}
            <div className="flex gap-3">
              {/* Batal */}
              <button
                onClick={() => setShowDeletePrompt(false)}
                className="flex-1 rounded-xl border border-gray-200 py-2.5 text-sm font-medium text-gray-600 transition-colors hover:bg-gray-50"
              >
                Batal
              </button>

              {/* Hapus */}
              <button
                onClick={handleConfirmDelete}
                className="flex-1 rounded-xl bg-red-500 py-2.5 text-sm font-bold text-white transition-colors hover:bg-red-600"
              >
                Hapus
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CardTestimoni;
